import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import {
  buildDespachoTeamActivityFeed,
  buildDespachoTeamActivityFetchParams,
} from "@/modules/despacho/despachoTeamActivity";

/**
 * Actividad reciente del equipo — chat interno + presencia (datos reales).
 */
export function useDespachoTeamActivity({ enabled = true, maxItems = 15 } = {}) {
  const { user } = useAuth();
  const [actividad, setActividad] = useState([]);
  const [loading, setLoading] = useState(Boolean(enabled && user));

  const reload = useCallback(async () => {
    if (!enabled || !user) {
      setActividad([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const [msgRes, presRes] = await Promise.all([
        api.get("/workspace/chat/messages", { params: buildDespachoTeamActivityFetchParams() }),
        api.get("/workspace/chat/presence", { timeout: 15000 }),
      ]);
      setActividad(
        buildDespachoTeamActivityFeed({
          messages: msgRes.data?.items || [],
          presenceItems: presRes.data?.items || [],
          maxItems,
          excludeUserId: user.id,
        }),
      );
    } catch {
      setActividad([]);
    } finally {
      setLoading(false);
    }
  }, [enabled, user, maxItems]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { actividad, loading, reload };
}
